import SalesListNew from '../components/reports/sales/new';
import NavLayout from '../components/layouts/NavLayout';

const SalesReportPage = () => {
	return (
		<section className="position-relative h-100">
			<NavLayout {...{ showBar: true }}>
				<SalesListNew />
			</NavLayout>
		</section>
	);
};

export default SalesReportPage;
